import { IAutomationAppComponent, IAutomationObject } from "../../types";
import { schema } from "./types";
import { OverviewPanel,OperatorPanel } from '.';
import { RiSunFoggyLine } from "react-icons/ri";
import { schemaTemperature, schemaHumidity, schema as schemaAnalogSensor } from '../../Devices/SensorAnalog/types'


export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: RiSunFoggyLine,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    createConfig:      {
        group: 'SubPlants',
        name: "Outside conditions",
        description: "Outside conditions",
        panel: OverviewPanel,
        defaultState: { },
    },
    addAppFilter: (app: IAutomationObject) => app.schema === schemaTemperature 
    || app.schema === schemaHumidity
    || app.schema === schemaAnalogSensor
}